<template>

    <div class="inv">
        <HeaderUI/>
        <main class="page-main">
            <div class="page-container">
                <div class="page-header">
                    <div>
                        <h1 class="page-title">Инвентаризация IT</h1>
                        <p class="page-description">Учёт техники и оборудования</p>
                    </div>
                </div>

                <ErrorAuthView :is-auth="isAuth"/>

                <section v-if="isAuth" class="card">
                    <div class="card-header">
                        <div class="card-title">Оборудование</div>
                    </div>
                    <div class="card-body">
                        <div class="empty">Раздел в разработке</div>
                    </div>
                </section>
            </div>
        </main>
    </div>

</template>


<script>

import HeaderUI from '@/components/HeaderUI.vue';
import ErrorAuthView from '@/components/ErrorAuthView.vue';
import { checkAuth } from '@/auth/auth';

export default {
    name: 'InventarizationView',

    components: {
        HeaderUI,
        ErrorAuthView
    },

    data() {
        return {
            isAuth: checkAuth(),
        }
    }
}

</script>


<style scoped>

.inv{
    width: 100%;
    min-height: 100vh;

    display: flex;
    flex-direction: column;
}

</style>
